import { Component } from '@angular/core';

@Component({
  selector: 'app-choix-sujet-contact',
  templateUrl: './choix-sujet-contact.component.html',
  styleUrls: ['./choix-sujet-contact.component.scss']
})
export class ChoixSujetContactComponent {

}
